module.exports = __webpack_public_path__ + "static/img/img36.85495b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img36.jpg
// module id = W1sK
// module chunks = 1